import { Quill } from "react-quill";

export const QUILL_FORMATS = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "list",
  "bullet",
  "color",
  "background",
  "link",
];

export const QUILL_MODULES_EDIT = {
  toolbar: [
    // [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ color: [] }, { background: [] }],
    ["link"],
    // ["clean"],
  ],
};

export const QUILL_MODULES_READONLY = { toolbar: false };

// Normalize to Quill Delta (ops) format.
export const normalizeToDelta = (content) => {
  if (!content) return { ops: [{ insert: "\n" }] };

  // Already delta
  if (typeof content === "object" && content?.ops && Array.isArray(content.ops)) return content;

  // Array: take first
  if (Array.isArray(content) && content.length > 0) return normalizeToDelta(content[0]);

  // String: convert HTML/text to delta
  if (typeof content === "string") {
    try {
      const tempQuill = new Quill(document.createElement("div"));
      tempQuill.clipboard.dangerouslyPasteHTML(content);
      const delta = tempQuill.getContents();
      if (delta && delta.ops && delta.ops.length > 0) return delta;
      return tempQuill.getContents();
    } catch (e) {
      console.warn("Error convirtiendo HTML a Delta:", e);
      return { ops: [{ insert: String(content) + "\n" }] };
    }
  }

  // Fallback: stringify
  try {
    const tempQuill = new Quill(document.createElement("div"));
    tempQuill.clipboard.dangerouslyPasteHTML(String(content));
    return tempQuill.getContents();
  } catch (e) {
    console.warn("Error normalizando objeto a Delta:", e);
    return { ops: [{ insert: JSON.stringify(content) + "\n" }] };
  }
};

export const escapeHtml = (s) =>
  String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

export const toQuillHtml = (value) => {
  if (!value) return "";
  const str = String(value);
  // If it already looks like HTML, trust it (backend-controlled).
  if (/<[a-z][\s\S]*>/i.test(str)) return str;
  // Otherwise, treat it as plain text.
  return `<p>${escapeHtml(str).replace(/\n/g, "<br/>")}</p>`;
};

export const deltaToPlainText = (delta) => {
  if (!delta?.ops || !Array.isArray(delta.ops)) return "";
  return delta.ops
    .map((op) => (typeof op?.insert === "string" ? op.insert : " "))
    .join("")
    .replace(/\s+/g, " ")
    .trim();
};

export const quillValueToPlainText = (value) => {
  if (!value) return "";
  if (Array.isArray(value) && value.length > 0) return quillValueToPlainText(value[0]);
  if (typeof value === "object" && value?.ops) return deltaToPlainText(value);
  return String(value || "")
    .replace(/<(.|\n)*?>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();
};

// Value for ReactQuill `value`: accepts Delta or HTML string.
export const toQuillDisplayValue = (value) => {
  if (!value) return "";
  if (Array.isArray(value) && value.length > 0) return toQuillDisplayValue(value[0]);
  if (typeof value === "object" && value?.ops) return value;
  return toQuillHtml(value);
};

